<template>
  <div>
    <el-row>
      <el-col :span="4"><div class="grid-content"></div></el-col>
      <el-col :span="16">
        <div class="grid-content" style='background-color:#fff;  box-shadow: 5px 5px 5px #999;'>
          <h2>友情链接</h2>
          <ul>
            <li v-for="item in tableListData" :key="item.id" >
              <a @click="jump(item)">{{item.name}}</a>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row>
      <el-col :span="4"><div class="grid-content1"></div></el-col>
      <el-col :span="16">
        <div class="grid-content1">
          <div style='height: 220px'>
            <ul>
              <li>
                <i class="el-icon-location-outline"></i>地址：{{this.tableData.address}}
              </li>
              <li>
                <i class="el-icon-phone-outline"></i>电话：{{this.tableData.phone}}
              </li>
              <li>
                <i class="el-icon-printer"></i>传真：{{this.tableData.fax}}
              </li>
              <li>
                <i class="el-icon-message"></i>邮箱：{{this.tableData.email}}
              </li>
            </ul>
            <div class='QR'>
              <el-image v-if="tableData.uploadImgAbsolutePath != null"
                        :src="loadImageStreamPath"
                        alt="logo"
                        :preview-src-list="imageList"
              ></el-image>
              <span>扫码关注微信公众号</span>
            </div>
          </div>
          <p>版权所有 © 广州城市可持续发展研究会</p>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content1"></div></el-col>
    </el-row>
  </div>
</template>

<script >
import { linksList, webConfigList } from '@/api/auth'

export default {
  created () {
    this.getList()
    this.webConfig()
  },
  methods: {
    /** 友情链接列表 */
    getList () {
      let that = this
      linksList(this.queryParams).then(res => {
        that.tableListData = res.data
      })
    },
    jump (raw) {
      window.open(raw.url, '_blank')
    },
    /** 查询网站配置 */
    webConfig () {
      let that = this
      webConfigList(this.queryParams).then(res => {
        console.log('-------------------------')
        that.tableData.address = res.data.address
        that.tableData.phone = res.data.phone
        that.tableData.fax = res.data.fax
        that.tableData.email = res.data.email
        that.tableData.id = res.data.id
        that.tableData.image_url = res.data.imageUrl
        that.tableData.uploadImgAbsolutePath = res.data.imageUrl

      })
    }
  },
  // 计算属性
  computed: {
    loadImageStreamPath: function () {
      if (this.tableData.uploadImgAbsolutePath == null) {
        return null;
      }
      return this.$baseUrl + "/upload/loadFileStreamByPath?path="+encodeURIComponent(this.tableData.uploadImgAbsolutePath);
    },
    imageList: function () {
      let imageList = []
      if (this.tableData.uploadImgAbsolutePath == null) {
        return []
      }
      imageList.push(this.$baseUrl + "/upload/loadFileStreamByPath?path="+encodeURIComponent(this.tableData.uploadImgAbsolutePath))
      return imageList;
    }
  },
  data() {
    return {
      tableListData: [],
      queryParams:{
      },
      tableData:{
        address: '',
        phone: '',
        fax: '',
        email: '',
        imageUrl: '',
        id: '',
        uploadImgAbsolutePath:'',
        uploadImgPath:''

      },
    }
  }
}
</script>

<style lang="less" scoped>
.el-row {
  padding-bottom: 20px;
  background-color: #eee;
  &:last-child {
    margin-bottom: 0;
  }
}
.grid-content {
  height: 65px;
  h2{
    font-size: 20px;
    font-weight: bold;
    line-height: 65px;
    padding:0 15px;
    display: block;
    float: left;
  }
  ul{
    li{
      float: left;
      padding:0 10px;
      font-size: 14px;
      line-height: 65px;
      a{
        color: #666;
      }
      a:hover{
        color: #409EFF;
      }
    }
  }
}
.grid-content1{
  height: 260px;
  background-color: #6aa84f;
  color: #fff;
  font-size: 14px;
  ul{
    width: 80%;
    padding-top: 40px;
    display: block;
    float: left;
    li{
      height: 40px;
      line-height: 40px;
      i{
        margin-right: 15px;
      }
    }
  }
  .QR{
    width: 130px;
    margin-top: 70px;
    float: right;
    img{
      width: 100px;
      display: block;
      margin: 5px auto;
    }
  }
  p{
    text-align: center;
  }
}
</style>
